// extracted by mini-css-extract-plugin
module.exports = {"modalBackground":"styles_modalBackground__rY11h","p0Login":"styles_p0Login__VgFIN","modal":"styles_modal__3JfaX","modalContent":"styles_modalContent__34BJ2"};